import "./about.1f7a2320.js";


      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $h9NR5 = parcelRequire("h9NR5");

var $7eXHk = parcelRequire("7eXHk");
const $8b4292de7e59a2b8$var$customVideoElement = document?.getElementById('vimeo-custom-video');
const $8b4292de7e59a2b8$var$customTabElement = document?.getElementById('vimeo-custom-tab');
const $8b4292de7e59a2b8$var$closeVideoElement = document?.getElementById('close-vimeo-modal');
const $8b4292de7e59a2b8$var$body = document?.querySelector('body');
const $8b4292de7e59a2b8$var$iframe = document.getElementById('vimeo-iframe');
const $8b4292de7e59a2b8$var$player = new Vimeo.Player($8b4292de7e59a2b8$var$iframe);
(0, $h9NR5.gsap)?.registerPlugin((0, $7eXHk.ScrollTrigger));
const $8b4292de7e59a2b8$var$toggleOpenCloseVideo = ()=>{
    $8b4292de7e59a2b8$var$body?.classList?.toggle('overflow');
    $8b4292de7e59a2b8$var$customVideoElement?.classList?.toggle('active');
    $8b4292de7e59a2b8$var$player?.getPaused()?.then(()=>{
        if ($8b4292de7e59a2b8$var$customVideoElement?.classList?.contains('active')) {
            $8b4292de7e59a2b8$var$player?.play();
            $8b4292de7e59a2b8$var$player?.setMuted(false);
        } else {
            $8b4292de7e59a2b8$var$player?.setMuted(true);
            $8b4292de7e59a2b8$var$player?.pause();
        }
    });
};
const $8b4292de7e59a2b8$var$initializeTrigger = ()=>{
    (0, $h9NR5.gsap)?.to("#vimeo-custom-tab", {
        scrollTrigger: {
            trigger: "#vimeo-custom-tab",
            start: "top 80%",
            end: "bottom 30%",
            scrub: true
        },
        opacity: 0
    });
};
$8b4292de7e59a2b8$var$customTabElement?.addEventListener('click', $8b4292de7e59a2b8$var$toggleOpenCloseVideo);
$8b4292de7e59a2b8$var$closeVideoElement?.addEventListener('click', $8b4292de7e59a2b8$var$toggleOpenCloseVideo);
$8b4292de7e59a2b8$var$initializeTrigger();


//# sourceMappingURL=flipside-www-2022.b49a8a5a.js.map
